import { SCREEN_PADDING_PERCENT } from '../../Renderer';

const getAlignGuideProperties = (screen) => {
  return {
    margin: screen.height * (SCREEN_PADDING_PERCENT / 100),
    weight: screen.height > screen.width ? 2 : 1, // 1px guides look too light at 9:16 aspectRatio for some reason
  };
};

export const horizontalAlignGuides = (screen) => {
  const { margin, weight } = getAlignGuideProperties(screen);

  return [
    {
      // north with margin
      graphics: null,
      x0: margin,
      y0: margin,
      x1: screen.width - margin,
      y1: margin,
      weight,
    },
    {
      // south with margin
      graphics: null,
      x0: margin,
      y0: screen.height - margin,
      x1: screen.width - margin,
      y1: screen.height - margin,
      weight,
    },
    {
      // north without margin
      graphics: null,
      x0: weight / 2,
      y0: weight / 2,
      x1: screen.width - weight / 2,
      y1: weight / 2,
      weight,
    },
    {
      // south without margin
      graphics: null,
      x0: weight / 2,
      y0: screen.height - weight / 2,
      x1: screen.width - weight / 2,
      y1: screen.height - weight / 2,
      weight,
    },
    {
      // horizontal center
      graphics: null,
      x0: weight / 2,
      y0: screen.height / 2,
      x1: screen.width,
      y1: screen.height / 2,
      weight,
    },
  ];
};

export const verticalAlignGuides = (screen) => {
  const { margin, weight } = getAlignGuideProperties(screen);

  return [
    {
      // east with margin
      graphics: null,
      x0: screen.width - margin,
      y0: margin,
      x1: screen.width - margin,
      y1: screen.height - margin,
      weight,
    },
    {
      // west with margin
      graphics: null,
      x0: margin,
      y0: margin,
      x1: margin,
      y1: screen.height - margin,
      weight,
    },
    {
      // east without margin
      graphics: null,
      x0: screen.width - weight / 2,
      y0: weight / 2,
      x1: screen.width - weight / 2,
      y1: screen.height - weight / 2,
      weight,
    },
    {
      // west without margin
      graphics: null,
      x0: weight / 2,
      y0: weight / 2,
      x1: weight / 2,
      y1: screen.height - weight / 2,
      weight,
    },
    {
      // vertical center
      graphics: null,
      x0: screen.width / 2,
      y0: weight / 2,
      x1: screen.width / 2,
      y1: screen.height,
      weight,
    },
  ];
};
